module.exports = __webpack_public_path__ + "static/img/6.49a10ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/6.png
// module id = Pr7H
// module chunks = 1